import request from '@/utils/request'

// 查询列表
export function apiScpMrpScheduleDatesList (query) {
  return request({
    url: '/scp/scpMrpScheduleDates/list',
    method: 'get',
    params: query
  })
}

// 修改
export function apiUpdateScpMrpScheduleDates (data) {
  return request({
    url: '/scp/scpMrpScheduleDates',
    method: 'put',
    data: data
  })
}

// 删除
export function apiDelScpMrpScheduleDates (id) {
  return request({
    url: `/scp/scpMrpScheduleDates/${id}`,
    method: 'delete'
  })
}
